module.exports = __webpack_public_path__ + "img/weixingongzhonghao.17643a3b.jpg";